import React from "react";

import { Grid } from "@mui/material";
import { Constants as GridConstants } from "Components/AppGrid/shipeezi-new-grid";
import { useTranslation } from "react-i18next";
import { BsPrinter } from "react-icons/bs";

import { CartonView } from "../../../../../../models/carton";
import { DefaultTooltip } from "../../../../Tooltip";
import useStyles, { LoadingStyled } from "../../../styles";

interface Props {
  carton?: CartonView;
  show?: boolean;
  loadingPrintLabel: boolean;

  handlePrintLabel: (sscc?: string) => void;
}

const PrintButton = (props: Props) => {
  const { carton, show, handlePrintLabel, loadingPrintLabel } = props;

  const { t: translate } = useTranslation();
  const classes = useStyles();

  if (!carton || !carton.isClosed || !show) return null;

  if (loadingPrintLabel) {
    return (
      <Grid item data-cy="print-sscc" className={classes.roundButton}>
        <LoadingStyled size={18} />
      </Grid>
    );
  }

  return (
    <Grid item data-cy="print-sscc" className={classes.roundButton}>
      <DefaultTooltip title={translate("printLabel")}>
        <div className={classes.printButton} onClick={() => handlePrintLabel(carton?.sscc)}>
          <BsPrinter
            size={GridConstants.defaultRowActionSize}
            color={GridConstants.defaultColorIcon}
          />
        </div>
      </DefaultTooltip>
    </Grid>
  );
};

export default PrintButton;
